module.exports = __webpack_public_path__ + "img/cogneetiv2.31744094.png";